export const SearchIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.52316 14.0939C11.1389 14.0939 14.0701 11.1628 14.0701 7.54696C14.0701 3.93118 11.1389 1 7.52316 1C3.90737 1 0.976196 3.93118 0.976196 7.54696C0.976196 11.1628 3.90737 14.0939 7.52316 14.0939Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0762 12.4399L14.6428 15"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
